import { ClientConfiguration } from '../main/client-config'

export class ClarityTracking {
  private static isInitialized = false

  static initialize(): void {
    if (this.isInitialized) {
      return
    }

    const projectId = 'tj8zuzownf'

    try {
      ;(function(c, l, a, r, i, t, y) {
        c[a] =
          c[a] ||
          function() {
            ;(c[a].q = c[a].q || []).push(arguments)
          }
        t = l.createElement(r)
        t.async = 1
        t.src = 'https://www.clarity.ms/tag/' + i
        y = l.getElementsByTagName(r)[0]
        y.parentNode.insertBefore(t, y)
      })(window, document, 'clarity', 'script', projectId)

      this.isInitialized = true
    } catch (error) {
      console.error('Failed to initialize Clarity:', error)
    }
  }

  static isLoaded(): boolean {
    return typeof window['clarity'] === 'function'
  }

  static getStatus(): void {
    console.log({
      isInitialized: this.isInitialized,
      isLoaded: this.isLoaded(),
      environment: ClientConfiguration.clientConfig.ENV || process.env.NODE_ENV
    })
  }
}
